export default __webpack_public_path__ + "static/media/diagram-icon.c0dab796.svg";